module.exports = __webpack_public_path__ + "static/img/1.54561d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/1.svg
// module id = EctT
// module chunks = 0